export enum RoutesName {
  login = '/login',
  terms = '/terms',
  home = '/',
  configuration = '/configuration',
  workflow = '/workflow',
  transition = '/transition',
  results = '/results/:operationId',
  ocr = '/results/:operationId/ocr',
  security = '/results/:operationId/security',
  verification = '/results/:operationId/verification',
  antiFraud = '/results/:operationId/antiFraud',
  notFound = '/notFound',
  government = '/results/:operationId/government',
  noAuthorized = '/noAuthorized',
  livenessFail = '/livenessFail',
  previousOnboardings = '/results/:operationId/previousOnboardings',
}

type ModelingList = {
  title: string;
  active: boolean;
  testId: string;
};

export enum Storage {
  token = 'TOKEN',
  refreshToken = 'REFRESH_TOKEN',
  operationId = 'OPERATION_ID',
}

export enum DeviceSize {
  mobile = 768,
  desktop = 769,
}

export enum TypeDocument {
  id = 'IDCard',
  driverLicense = 'DriversLicense',
  passport = 'Passport',
  residentID = 'ResidentID',
  custom = 'Custom',
}

export enum TypeDocumentDTO {
  IDCard = 'ID_CARD',
  DriversLicense = 'DRIVING_LICENSE',
  Passport = 'PASSPORT',
  ResidentID = 'RESIDENCE_ID',
  Custom = 'CUSTOM',
  Visa = 'VISA',
}

export const DocumentTypeEngineList = {
  0: 'UNKNOWN',
  1: 'NONE',
  2: 'ID',
  3: 'PASSPORT',
  4: 'VISA',
  5: 'GREEN_CARD',
  6: 'DRIVING_LICENSE',
  7: 'RESIDENT_ID',
  8: 'SOCIAL_SECURITY_CARD',
  9: 'HEALTH_INSURANCE_CARD',
  10: 'TEMPORARY_RESIDENCE',
};

export enum FrontToBackTypeDocument {
  IDCard = 'ID_CARD',
  DriversLicense = 'DRIVING_LICENSE',
  Passport = 'PASSPORT',
  ResidentID = 'RESIDENT_ID',
  Custom = 'CUSTOM',
  Visa = 'VISA',
}

export enum TypeDocumentBackend {
  DRIVING_LICENSE = 'DRIVING_LICENSE',
  FOREIGN_CARD = 'FOREIGN_CARD',
  ID = 'ID_CARD',
  PASSPORT = 'PASSPORT',
  VISA = 'VISA',
  RESIDENT_ID = 'FOREIGN_CARD',
  RESIDENT_PERMIT = 'RESIDENCE_PERMIT',
}

export const ModelingList: { [key in TypeDocument]: ModelingList } = {
  [TypeDocument.custom]: {
    title: 'Auto',
    active: true,
    testId: 'settings_model_auto_read_option',
  },
  [TypeDocument.id]: {
    title: 'Identity card',
    active: true,
    testId: 'settings_model_id_card_option',
  },
  [TypeDocument.driverLicense]: {
    title: 'Drivers license',
    active: true,
    testId: 'settings_model_drive_license_option',
  },
  [TypeDocument.passport]: {
    title: 'Passport',
    active: true,
    testId: 'settings_model_passport_option',
  },
  [TypeDocument.residentID]: {
    title: 'Residence card',
    active: true,
    testId: 'settings_model_foreign_card_option',
  },
};

export enum AuthName {
  token = 'TOKEN',
  refreshToken = 'REFRESH_TOKEN',
}

export const REQUIRED_VALIDATION = 'This field is required';

export const endPoints = {
  Authenticate: {
    Matching: '/api/authenticate/matching',
    Liveness: '/api/authenticate/liveness',
    Antispoofing: '/api/authenticate/antispoof',
  },
  Terms: '/tac',
  TermsAcceptance: '/tac/acceptance',
  Workflows: {
    Start: '/workflows',
    Assets: '/assets',
    Results: '/operations',
  },
};

export const DOCUMENT_FACIAL = 'DOCUMENT_FACIAL_CAPTURE';
export const DOCUMENT_SELFIE = 'SELFIE';
export const DOCUMENT_FRONT = 'DOCUMENT_FRONT';
export const DOCUMENT_BACK = 'DOCUMENT_BACK';

export const ACTIVE_COUNTRIES = [
  'AE',
  'AR',
  'BO',
  'BR',
  'CL',
  'CO',
  'KR',
  'CR',
  'EC',
  'SV',
  'ES',
  'GT',
  'HN',
  'LT',
  'MX',
  'NI',
  'PA',
  'PE',
  'PT',
  'DO',
  'UY',
  'VE',
  'GB',
];

export const DEFAULT_COUNTRY = 'XXX';

export const REFUSAL_REASON = 'Refusal Reason';

export const SELPHI_SDK = 'FACEPHI-SELPHI';
export const SELPHI_WIDGET = 'FACEPHI-SELPHI-WIDGET';

export const DEFAULT_TIMEZONE = 'Europe/Madrid';

export enum Environments {
  development = 'development',
  production = 'production',
  test = 'test',
}

export const TRUE_REGEXP = /^true$/i;
export const FINISH_TIMEOUT = 150000;
export const SSE_CONNECTION_TIMEOUT = 30000;
export const WEB_SOURCE = 'web';
export const PLATFORM_SUBDIRECTORY = '/operations';
export const POLLING_ATTEMPTS_LIMIT = 6;
export const DEMOS_BE = 'demos-backend';
export const CORRESPONDENCE_THRESHOLD = 50;
